namespace Serenity {
    export interface OperationCancelRequest extends Serenity.ServiceRequest {
        OperationGuid?: string;
    }
}
